import './services.css'
import { useSelector} from 'react-redux'
import { useState,useEffect } from "react";

function Services (){
let boolean = useSelector((state) => state.boolean.bool)
let [texte,setTexte]=useState()
let [titre,setTitre]=useState()

console.log("test et test"+boolean)
useEffect(() => {
  // Update the document title using the browser API
  if(boolean===false){
    setTexte(texteFR)
    setTitre(titreFR)
 }
 else{
  setTexte(texteANG)
  setTitre(titreENG)
 }
 console.log(texte)
});
//le textes en deux langues
let texteFR="Nous comprenons l’importance de livrer nos services dans les délais et selon le plan prévu. Notre équipe de techniciens experts et de chefs de projet font tout ce qui est nécessaire pour que  chaque projet soit terminé à temps et dans les limites du budget. Grâce à nos intégrateurs audiovisuels qualifiés, nous garantissons la qualité de nos réalisations ainsi que la bonne exécution de l’ensemble de nos services. Avec notre expérience reconnue, vous pouvez être tranquille : votre projet sera réalisé rapidement, efficacement et à votre entière satisfaction.";
let texteANG="We understand the importance of delivering our services on time and according to plan. Our team of expert technicians and project managers does everything necessary to ensure that each project is completed on time and within budget. Thanks to our qualified audiovisual integrators, we guarantee the quality of our work and the successful execution of all our services. With our proven track record, you can rest assured: your project will be completed quickly, efficiently, and to your complete satisfaction.";

let titreFR= "Respect des Délais et Qualité Garantie"
let titreENG= "On-Time Delivery and Guaranteed Quality"


//changer de langue


  return (
    <section className="servicesSectionText">
      <h3 className="servicesTitle">{titre}</h3>
      <p>{texte}</p>
    </section>
  )
}
export default Services;